export default "__VITE_ASSET__Db$wtpj8__"